import { AfterViewInit, Injectable, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

@Injectable()
export abstract class BaseController implements OnInit, OnDestroy, AfterViewInit {

	subs: Array<Subscription> = [];

	ngOnInit(): void { }

	ngAfterViewInit(): void { }

	ngOnDestroy(): void {
		if (this.subs)
			this.subs.forEach(x => x.unsubscribe());
	}
}